<template>
  <component :is="$attrs.is || 'div'" v-if="$slots.default" class="max-w-9xl mx-auto px-s lg:px-m xl:px-xl">
    <slot />
  </component>
</template>
